"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueType = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.ValueType = {
  name: 'ValueType',
  list: {
    resultsVariant: 'list'
  },
  form: {
    fields: create_entity_1.entityTaxonomyFormFields
  },
  select: {
    maxWidth: '400px'
  },
  autoRoutes: ['list', 'create', 'update']
};